module.exports = __webpack_public_path__ + "static/media/ic_tag_label_plural.f208f254.svg";